import { createBrowserRouter } from "react-router-dom";
// layouts
import { ConsoleLayout } from "@/layouts/console";
// pages
import { LoginPage } from "@/pages/login";
import { OperatorHomePage } from "@/pages/operator/home";
import { TenantHomePage } from "@/pages/tenant/home";
// routes
import { operatorRoutes } from "./routes/operator";
import { tenantRoutes } from "./routes/tenant";
// guards
import { AuthGuard } from "./guards";
import { NotFoundPage } from "@/pages/error/NotFound";

export let router: ReturnType<typeof createBrowserRouter>;

export const createRouter = (isOperator: boolean) => {
  router = createBrowserRouter([
    {
      path: "/",
      element: (
        <AuthGuard>
          <ConsoleLayout />
        </AuthGuard>
      ),
      children: isOperator
        ? [
            {
              index: true,
              element: <OperatorHomePage />,
            },
            ...operatorRoutes,
          ]
        : [
            {
              index: true,
              element: <TenantHomePage />,
            },
            ...tenantRoutes,
          ],
    },
    {
      path: "/login",
      element: <LoginPage />,
    },
    {
      path: "*",
      element: <NotFoundPage />,
    },
  ]);

  return router;
};
